import { METRICS_API_URL } from './metricsEnum.js';
import createService from 'shared/utils/createService.js';

export default createService(METRICS_API_URL);
